import Vue from 'vue'

export default {
  methods: {

    displayReportPDF(link) {
      let routeData = this.$router.resolve(link)
      window.open(routeData.href, '_blank')
    },

    // Given PDF data, invoke a download/display on it
    // Required as the REST API requires Auth, so we've requested a signed URL first and then we'll invoke that link
    // instead of simply clicking a link
    invokePDFLink(reportLink) {
      var link = document.createElement('a');
      link.href = reportLink;
      link.download="report.pdf";
      link.click();
    }
  }
}